// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"caret-up-small","fill":"currentColor","d":"M12.0001 9L17.5 14.5L6.5 14.5L12.0001 9Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-caret-up-small')
export default class CaretUpSmallIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'caret-up-small',
    }
  }
}
